<template>
    <div>
      <div class="security-style" v-if="isMobile">
        <toppage></toppage>
        <div class="security-main">
          <div class="mian-header">
            <div class="header-content">
              <h1>图链安全实验室研究报告</h1>
              <div class="info-content">

<div class="section-left">
    <img src="../../../assets/image/security/topright.png" alt="">
  <div class="left-content">
    <h2>公开版多签授权诈骗报告</h2>
    <div class="leftspan-info">

      <span class="left-span">图链安全实验室对波场（Tron）链上多签授权诈骗进行调查和披露，揭示诈骗团伙的具体作案手法，希望能为公众提供安全警示与建议。
      </span>
    </div>


     <div class="left-button">
<a href="https://static.graphchain.top/sites/top/pdf/%E5%A4%9A%E7%AD%BE%E6%8E%88%E6%9D%83%E8%AF%88%E9%AA%97%E6%8A%A5%E5%91%8A%E5%85%AC%E5%BC%80%E7%89%88.pdf" target="_blank"
>立即查看&nbsp;→</a
>
</div>
  </div>
  

</div>
<div class="section-right">
    <img src="../../../assets/image/security/topleft.png" alt="">
  <div class="left-content">
    <h2>公安版多签授权诈骗报告</h2>
    <div class="leftspan-info">

      <span class="left-span">报告通过对波场（Tron）链上多签授权诈骗的统计与分析，揭示其作案手法、趋势、技术特征及社会危害性，为公安机关侦破此类案件提供技术支持和决策参考依据。</span>
    </div>
     <div id="viewbutton" class="left-button" @click="viewbutton">
立即查看&nbsp;→
<div class="button-content">

  <div class="navfree-mask" v-show="isfree">
<!-- <span class="close-style" @click="closenavfreefn">x</span> -->

<div class="mask-content">
<span class="mask-top">公安版领取方式</span>
<img
src="@/assets/image/homePage/mainbottom/weixinimg.png"
alt=""
/>
<span>扫码添加官方客服二维码获取报告</span>
</div>
</div>
</div>
</div>
  </div>
  
</div>
</div>
              
            </div>
          </div>
          <div class="main-content">
         
            <h1>图链安全资讯</h1>
<div>
  <div class="currency-content" v-for="(item, index) in data" :key="index">
                        <a v-if="item.point" :href="item.link" target="_blank"  class="content-info">
                            <img
                      :src="getImageUrl(item.img)"
                      alt=""
                    />
                          <h2>{{item.title}}</h2>
                          <span class="content-text"
                            >{{item.text}}</span
                          >
                          <!-- <span class="content-time">{{item.time}}</span> -->
                        </a>
                   
                      </div>
</div>
  </div>
          <footerpage></footerpage>
        </div>
        <img class="scroll-button" v-if="showButton"  @click="scrollToTop" src="@/assets/image/newhome/huidaodingbu.png" alt="">
  
      </div>
      <div class="security-style" v-else>
        <full-page :options="options" ref="fullpage">
          <div class="section security-top">
            <div>
              <div class="security-nav">
                <navbar classname="security"></navbar>
              </div>
              <div class="section-content">
                <div class="top-title">
                  <div class="title-content">
                    <h1>图链安全实验室研究报告</h1>
                    <div class="info-content">

                        <div class="section-left">
                            <img src="../../../assets/image/security/topright.png" alt="">
                          <div class="left-content">
                            <h2>公开版多签授权诈骗报告
                                </h2>
                            <span class="left-span">图链安全实验室对波场（Tron）链上多签授权诈骗进行调查和披露，揭示诈骗团伙的具体作案手法，希望能为公众提供安全警示与建议。</span>
                             <div class="left-button">
                      <a href="https://static.graphchain.top/sites/top/pdf/%E5%A4%9A%E7%AD%BE%E6%8E%88%E6%9D%83%E8%AF%88%E9%AA%97%E6%8A%A5%E5%91%8A%E5%85%AC%E5%BC%80%E7%89%88.pdf" target="_blank"
                        >立即查看&nbsp;→</a
                      >
                    </div>
                          </div>
                          

                        </div>
                        <div class="section-right">
                            <img src="../../../assets/image/security/topleft.png" alt="">
                          <div class="left-content">
                            <h2>公安版多签授权诈骗报告
                               </h2>
                            <span class="left-span">本报告通过对波场（Tron）链上多签授权诈骗的统计与分析，揭示其作案手法、趋势、技术特征及社会危害性，为公安机关侦破此类案件提供技术支持和决策参考依据。</span>
                             <div id="viewbutton" class="left-button" @click="viewbutton">
                      立即查看&nbsp;→
                      <div class="button-content">

                          <div class="navfree-mask" v-show="isfree">
                  <!-- <span class="close-style" @click="closenavfreefn">x</span> -->
    
                  <div class="mask-content">
                    <span class="mask-top">公安版领取方式</span>
                    <img
                      src="@/assets/image/homePage/mainbottom/weixinimg.png"
                      alt=""
                    />
                    <span>扫码添加官方客服二维码获取报告</span>
                  </div>
                </div>
                      </div>
                    </div>
                          </div>
                          
                        </div>
                    </div>
                    <!-- <h2>公安部经侦应用云推荐研判工具</h2> -->
                    <!-- <div class="info-content">
                      <a href="https://dashboard.graphchain.top" target="_blank"
                        >进入图链</a
                      >
                    </div> -->
                  </div>
                  <!-- <div class="title-info">
  
                    <div class="info-content">
  
  <a href="https://dashboard.graphchain.top" target="_blank">进入图链</a>
  </div>
  
             
                   
                  </div> -->
                  <!-- <div class="title-content">
               <img src="@/assets/image/newhome/businessintroduce/bannerbeijing.gif" alt="">
              </div> -->
                </div>
              </div>
            </div>
          </div>
  
          <div class="section security-profession">
            <div
              class="profession-content animated-element1"
              v-show="isprofession"
            >
              <div class="profession-box">
                <div class="profession-main">
                  <div class="profession-info">
                    <h1>图链安全资讯</h1>
          
                    <div class="security-currency">
  
                      <div class="currency-content" v-for="(item, index) in data" :key="index">
                        <a v-if="item.point" :href="item.link" target="_blank"  class="content-info">
                            <img
                      :src="getImageUrl(item.img)"
                      alt=""
                    />
                          <h2>{{item.title}}</h2>
                          
                          <span
                            >{{item.text}}</span
                          >
                          <!-- <span class="content-time">{{item.time}}</span> -->
                        </a>
                   
                      </div>
                   <!-- 分页按钮 -->
     <!-- Element UI 分页组件 -->
      <!-- <div class='content-pagination'>
          <el-pagination
           v-if="totalPages > 1"
           background
           layout="prev, pager, next"
           :current-page="currentPage"
           :page-size="pageSize"
           :total="data.length"
           @current-change="handlePageChange"
         />
      </div> -->
                    </div>
                  </div>
  
                  <!-- <div class="liucheng-button">
                <span>联系我们</span>
              </div> -->
                </div>
              </div>
              <div class="profession-bottom">
                <newfooter></newfooter>
              </div>
            </div>
          </div>
        </full-page>
        <div></div>
      </div>
    </div>
  </template>
  <script>
  import navbar from "@/components/navbar.vue";
  import newfooter from "@/components/newfooter.vue";
  import Swiper from "swiper";
  import toppage from "@/views/newhome/toppage.vue";
  import footerpage from "@/views/newhome/footerpage.vue";
  import { getMockData } from '@/utils/api';
  // import countTo  from 'vue-count-to';
  // import CountUp from "countup"
  export default {
    components: {
      navbar,
      newfooter,
      toppage,
      footerpage,
      // countTo
    },
    data() {
      return {
        data: [],
        currentPage: 1, // 当前页
      pageSize: 6 ,// 每页显示条数
        isfree:false,
        showButton: false,
        scrollThreshold: 400,
        deviceType: this.getDeviceType(),
        // isshebi:false,
        isMobile: false,
        iscorebusiness1: false,
        iscorebusiness2: false,
        isprofession: false,
        screenWidth: 0,
        bannerHeight: 0,
        options: {
          licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
          //是否显示导航，默认为false
          navigation: true,
          afterLoad: this.afterLoad,
          onLeave: this.onLeave,
  
          //为每个section设置背景色
          // sectionsColor: [
          //     "#41b883",
          //     "#ff5f45",
          //     "#0798ec",
          //     "#fec401",
          //     "#1bcee6",
          //     "#ee1a59",
          //     "#2c3e4f",
          //     "#ba5be9",
          //     "#b4b8ab"
          // ],
        },
      };
    },
    computed: {
    // 计算当前页的数据
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.data.slice(start, start + this.pageSize);
    },
    // 计算总页数
    totalPages() {
      return Math.ceil(this.data.length / this.pageSize);
    }
  },
    methods: {
       // Element UI 分页触发
    handlePageChange(page) {
      this.currentPage = page;
    },
        getImageUrl(imgName) {
      return require(`@/assets/image/security/${imgName}`);
    },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      },
      getDeviceType() {
        return window.innerWidth < 768 ? "手机" : "电脑";
      },
      viewbutton(){
        this.isfree=!this.isfree
      },
      handleResize() {
        this.deviceType = this.getDeviceType();
      },
      checkMobile() {
        this.isMobile = window.innerWidth <= 1199;
      },
      //   onLeave(index, direction){
      //   console.log(index, direction);
      // },
      afterLoad(anchorLink, index) {
        console.log(anchorLink, index);
        console.log("Emitted 'after load' event.");
        //获取body的classname，跟随section滑动刷新
        let a = document.body.className;
        console.log(a);
        //在第几页控制相关逻辑
        //   if(a !== 'fp-scroll-mac fp-viewing-0' || a !== 'fp-viewing-0'){
        //     this.isshebi=false
        //   }
  
        if (a !== "fp-scroll-mac fp-viewing-1" || a !== "fp-viewing-1") {
          this.isprofession = false;
        }
        if (a === "fp-scroll-mac fp-viewing-1" || a === "fp-viewing-1") {
          // console.log(eee);
          this.isprofession = true;
        }
        // else if(a === 'fp-scroll-mac fp-viewing-0' || a === 'fp-viewing-0'){
        //   this.isshebi=true
        // }
      },
  
      next() {
        // 向下滚动一页
        this.$refs.fullpage.api.moveSectionUp();
        // this.$refs.fullpage.goTo(0);
      },
    },
    // created(){     location.reload()},
    mounted() {
      var mySwiper = new Swiper(".swiper-container", {
        // loop: true,
        loopAdditionalSlides: 1,
        width: window.innerWidth,
        slidesPerView: "auto",
        spaceBetween: 30,
        // width:30,
        // grabCursor : true,
        // initialSlide :1,
  
        // centeredSlides: true,
        // centeredSlidesBounds: true,
        // 如果需要分页器
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
  
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
  
      if (this.deviceType != "手机" && !this.isMobile) {
        this.next();
      }
      if(this.isMobile){
  
  window.addEventListener('scroll', () => {
    this.showButton = window.scrollY > this.scrollThreshold;
  });
  }
  document.addEventListener("click", (e) => {
      const viewbutton = document.getElementById("viewbutton");

      if (viewbutton) {
        if (!viewbutton.contains(e.target)) {
          this.isfree = false;
        }
      }
    });
        
      // 首次加载时,初始化高度
      // this.screenWidth = window.innerWidth;
      // this.bannerHeight = (450 / 1450) * this.screenWidth;
      // // 窗口大小发生改变
      // window.onresize = () => {
      //   this.screenWidth = window.innerWidth;
      //   this.bannerHeight = (450 / 1450) * this.screenWidth;
      // };
    },
    async  created() {
      this.checkMobile();
      window.addEventListener("resize", this.checkMobile);
      window.addEventListener("resize", this.handleResize);
      let datalist=await getMockData();
      this.data = datalist.reverse()
    },
    destroyed() {
      window.removeEventListener("resize", this.handleResize);
      window.removeEventListener('scroll', () => {});
  
    },
  };
  </script>
  <style>
  .fp-warning,
  .fp-watermark {
    display: none !important;
  }
  </style>
  
  <style lang="scss" scoped>
  @import "@/assets/scss/security.scss";
  </style>
  